import { observable } from "mobx";
import { Type } from "class-transformer";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import RefundApprovalResponse from "./refundApprovalResponse";
import RefundChargeDetailResponse from "./refundChargeDetailResponse";
import RefundFeeResponse from "./refundFeeResponse";
import RefundOriginalTransferPaymentDetailResponse from "./refundOriginalTransferPaymentDetailResponse";
import RefundPermittedActionsResponse from "./refundPermittedActionsResponse";
import RefundTransferPaymentResponse from "./refundTransferPaymentResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class RefundForRefundOfRefundDetailResponse {
  id!: string;

  @observable
  refundPaymentTemplateId!: string;

  @observable
  refundAmount!: number;

  @observable
  @Type(() => RefundChargeDetailResponse)
  charge?: RefundChargeDetailResponse;

  @observable
  @Type(() => RefundFeeResponse)
  fees!: RefundFeeResponse[];

  @observable
  @Type(() => RefundPermittedActionsResponse)
  permittedActions!: RefundPermittedActionsResponse;

  @observable
  @Type(() => RefundApprovalResponse)
  approvals!: RefundApprovalResponse[];

  @observable
  @Type(() => Date)
  originalRefundPostingDate!: Date;

  @observable
  originalRefundOfficialRecordId?: string;

  @observable
  @Type(() => RefundOriginalTransferPaymentDetailResponse)
  originalPayment!: RefundOriginalTransferPaymentDetailResponse;

  @observable
  @Type(() => RefundTransferPaymentResponse)
  refundPayment!: RefundTransferPaymentResponse;

  @observable
  @Type(() => DomesticBankAccountResponse)
  refundSenderBankAccount!: DomesticBankAccountResponse;
}

export default class RefundForRefundOfRefundDetail extends RefundForRefundOfRefundDetailResponse {
  @observable
  isSelectable: boolean;
}
